module.exports = __webpack_public_path__ + "static/media/hall-AE.ac69fbbd.svg";